{
  "mercury": {
    "title": "Mercury",
    "facts": [
      "Smallest planet in our solar system",
      "Closest planet to the Sun (57.9 million km)",
      "Surface temperature ranges from -180°C to 430°C",
      "Has no moons or rings",
      "Takes 88 Earth days to orbit the Sun",
      "Named after the Roman god of speed",
      "Has a very thin atmosphere",
      "Diameter is 4,879 km"
    ]
  },
  "venus": {
    "title": "Venus",
    "facts": [
      "Hottest planet in our solar system (462°C)",
      "Often called Earth's sister planet due to similar size",
      "Rotates backwards compared to most planets",
      "Has the longest rotation period of any planet (243 Earth days)",
      "Named after the Roman goddess of love",
      "Thick atmosphere of carbon dioxide",
      "No moons or rings",
      "Diameter is 12,104 km"
    ]
  },
  "earth": {
    "title": "Earth",
    "facts": [
      "Only known planet with life",
      "Has one natural satellite (the Moon)",
      "Takes 365.25 days to orbit the Sun",
      "Only planet not named after a god/goddess",
      "71% of surface covered in water",
      "Has a protective magnetic field",
      "Average surface temperature is 15°C",
      "Diameter is 12,742 km"
    ]
  },
  "mars": {
    "title": "Mars",
    "facts": [
      "Known as the Red Planet",
      "Has two small moons (Phobos and Deimos)",
      "Surface temperature ranges from -140°C to 20°C",
      "Named after the Roman god of war",
      "Has the largest volcano in the solar system (Olympus Mons)",
      "Takes 687 Earth days to orbit the Sun",
      "Has polar ice caps made of water and CO2",
      "Diameter is 6,779 km"
    ]
  },
  "jupiter": {
    "title": "Jupiter",
    "facts": [
      "Largest planet in our solar system",
      "Has at least 95 moons",
      "Great Red Spot is a giant storm lasting over 400 years",
      "Named after the king of the Roman gods",
      "Takes 12 Earth years to orbit the Sun",
      "Made mostly of hydrogen and helium",
      "Has a faint ring system",
      "Diameter is 139,820 km"
    ]
  },
  "saturn": {
    "title": "Saturn",
    "facts": [
      "Known for its spectacular ring system",
      "Has at least 83 moons (including Titan)",
      "Named after the Roman god of agriculture",
      "Takes 29.5 Earth years to orbit the Sun",
      "Could float in a giant bathtub (less dense than water)",
      "Mostly made of hydrogen and helium",
      "Average temperature is -178°C",
      "Diameter is 116,460 km"
    ]
  },
  "uranus": {
    "title": "Uranus",
    "facts": [
      "First planet discovered using a telescope",
      "Rotates on its side (98-degree tilt)",
      "Has 27 known moons",
      "Named after the Greek god of the sky",
      "Takes 84 Earth years to orbit the Sun",
      "Has a blue-green color due to methane",
      "Temperature as low as -224°C",
      "Diameter is 50,724 km"
    ]
  },
  "neptune": {
    "title": "Neptune",
    "facts": [
      "Most distant planet from the Sun",
      "Has 14 known moons",
      "Strongest winds in the solar system (2,100 km/h)",
      "Named after the Roman god of the sea",
      "Takes 165 Earth years to orbit the Sun",
      "Has a dark spot similar to Jupiter's",
      "Average temperature is -214°C",
      "Diameter is 49,244 km"
    ]
  }
} 